import { XCircle, RefreshCw } from "lucide-react";
import { NormasTeachingCheckoutScreenPath } from "./NormasTeachingCheckoutScreen.tsx";
import { useSearchParams } from "react-router";
import { Layout } from "../UI/Layout/Layout.tsx";
import { NavBar } from "../UI/Layout/NavBar.tsx";
import { Footer } from "../UI/Layout/Footer.tsx";

function useOrderFromQuery(): {
  orderId: string | undefined;
  productType: string | undefined;
  normasTeachingProductId: string | undefined;
} {
  const [searchParams] = useSearchParams();

  const orderId = searchParams.get("orderId") ?? undefined;
  const productType = searchParams.get("productType") ?? undefined;
  const normasTeachingProductId =
    searchParams.get("normasTeachingProductId") ?? undefined;

  return {
    orderId,
    productType,
    normasTeachingProductId,
  };
}

export const NormasTeachingCheckoutStripePaymentFailurePath =
  "/normasteachingproduct/checkout/stripe-payment-failure";

export const NormasTeachingCheckoutStripePaymentFailure = () => {
  const { productType, normasTeachingProductId } = useOrderFromQuery();
  function createProductUrl(): string {
    const url = new URL(
      NormasTeachingCheckoutScreenPath,
      window.location.origin,
    );
    url.searchParams.set(
      productType == "bundle" ? "bundleId" : "productId",
      normasTeachingProductId ?? "",
    );
    return url.toString();
  }

  const handleRetry = () => {
    window.open(createProductUrl(), "_blank", "noopener,noreferrer");
  };

  return (
    <Layout>
      <NavBar />
      <div className="flex-1 bg-gradient-to-br from-red-50 to-orange-50 flex items-center justify-center p-4">
        <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
          {/* Icona di errore */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-red-100 rounded-full blur-xl opacity-50 animate-pulse"></div>
              <XCircle
                className="relative w-20 h-20 text-red-500"
                strokeWidth={1.5}
              />
            </div>
          </div>

          {/* Titolo */}
          <h1 className="text-2xl font-bold text-gray-900 mb-3">
            Ops… qualcosa è andato storto.
          </h1>

          {/* Messaggio */}
          <p className="text-gray-600 mb-2">
            Il tuo pagamento non è stato completato.
          </p>
          <p className="text-sm text-gray-500 mb-8">
            Nessun addebito è stato effettuato.
          </p>

          {/* Pulsanti di azione */}
          <div className="space-y-3">
            <button
              onClick={handleRetry}
              className="w-full bg-red-500 hover:bg-red-600 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
            >
              <RefreshCw className="w-5 h-5" />
              Riprova il pagamento
            </button>
          </div>

          {/* Link di supporto */}
          <div className="mt-8 pt-6 border-t border-gray-100">
            <p className="text-sm text-gray-500 mb-2">
              Se il problema persiste, contatta il tuo consulente didattico di
              riferimento oppure {``}
              <a
                href="mailto:help@normasteaching.com"
                className="text-sm text-red-500 hover:text-red-600 font-medium underline"
              >
                contatta il supporto
              </a>
            </p>
            <p className="text-sm text-gray-500">Grazie per la pazienza 💙</p>
          </div>
        </div>
      </div>
      <Footer />
    </Layout>
  );
};
